import { ExclamationCircleFill } from "react-bootstrap-icons";
import styles from "./CaseProduction.module.scss";

export default function BatchError() {
  return (
    <div className={`${styles.errorAlert} d-flex gap-2 p-2`}>
      <div className="d-flex gap-2 align-items-center">
        <ExclamationCircleFill className="text-danger" />
        <p className="fs-5 fw-bold m-0" style={{ color: "var(--text)" }}>
          We've encountered an issue processing your documents. Please contact{" "}
          <a href="mailto:support@briefpoint.ai">support@briefpoint.ai</a> for
          assistance.
        </p>
      </div>
    </div>
  );
}
